import styled from 'styled-components/macro'

export default styled.div`
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  padding-bottom: ${props => props.theme.halfSpace};
  margin-bottom: ${props => props.theme.halfSpace};
  &:not(:last-child) {
    border-bottom: 1px solid ${props => props.theme.colors.gray[4]};
  }
`

export const GiftListHeader = styled.header`
  background-color: #fff;
  width: 100%;
  height: 40px;
  margin-top: ${props => props.theme.halfSpace};
  padding: ${props => props.theme.padding} 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${props => props.theme.fontSize.header};
  color: ${props => props.theme.colors.gray[0]};
  cursor: ${props => props.cursor || 'pointer'};
`

export const GiftListItems = styled.section`
  width: 100%;
  transition: all .3s ease-in-out;
  height: ${props => props.collapsed ? 0 : props.height};
  overflow: hidden;
`

export const Toggle = styled.img`
  transition: all .5s ease-in-out;
  transform:  ${props => props.collapsed ? 'rotate(90deg)' : 'none'};

  &.star {
    transform:  ${props => props.collapsed ? 'rotate(180deg)' : 'none'};
    margin-right: 8px;
  }
`

export const Title = styled.div`
  
`
